import { useEffect, useRef } from 'react';

/** Guard asynchronous UI updates after this viewer unmounts. */
export function useMountedRef() {
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return mounted;
}
